"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryPayload = exports.FilterInfo = exports.ProjectionInfo = exports.TableInfo = exports.AttributeList = exports.Attribute = exports.ModifierInfo = void 0;
const typescript_json_serializer_1 = require("typescript-json-serializer");
const base_1 = require("../common/base");
const constants_1 = require("../../constants");
const constant_1 = require("../../constants/constant");
const geofencing_1 = require("./geofencing");
const segmentinfo_1 = require("./segmentinfo");
/**
 * Represents the pagination part of the query about the table/projection/.
 */
class ModifierInfo {
    constructor(limit, orderBy, orderByName) {
        this.limit = limit;
        this.orderBy = orderBy;
        orderByName = orderByName;
    }
}
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Number)
], ModifierInfo.prototype, "limit", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], ModifierInfo.prototype, "orderBy", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], ModifierInfo.prototype, "orderByName", void 0);
exports.ModifierInfo = ModifierInfo;
/**
 * Represents information about attribute
 */
let Attribute = class Attribute {
    constructor(operand, operator, value, type, e_operator) {
        this.operand = operand;
        this.operator = operator;
        this.value = value;
        this.type = type;
        this.e_operator = e_operator;
    }
};
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], Attribute.prototype, "operand", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], Attribute.prototype, "operator", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Array)
], Attribute.prototype, "value", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], Attribute.prototype, "type", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], Attribute.prototype, "e_operator", void 0);
Attribute = __decorate([
    (0, typescript_json_serializer_1.JsonObject)(),
    __metadata("design:paramtypes", [String, String, Array, String, String])
], Attribute);
exports.Attribute = Attribute;
//Represents information about attribute list
let AttributeList = class AttributeList {
    constructor(operand, type) {
        this.operand = operand;
        this.type = type;
    }
};
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], AttributeList.prototype, "operand", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], AttributeList.prototype, "type", void 0);
AttributeList = __decorate([
    (0, typescript_json_serializer_1.JsonObject)(),
    __metadata("design:paramtypes", [String, String])
], AttributeList);
exports.AttributeList = AttributeList;
/**
 * Represents the information about the table.
 */
let TableInfo = class TableInfo {
    constructor(tableName, appId, modifierInfo, // this will. be used in future , Currently not in support
    name) {
        this.tableName = tableName;
        this.appId = appId,
            this.modifierInfo = modifierInfo; // this will. be used in future , Currently not in support
        this.name = name;
    }
};
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], TableInfo.prototype, "tableName", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", ModifierInfo)
], TableInfo.prototype, "modifierInfo", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], TableInfo.prototype, "appId", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], TableInfo.prototype, "name", void 0);
TableInfo = __decorate([
    (0, typescript_json_serializer_1.JsonObject)(),
    __metadata("design:paramtypes", [String, String, ModifierInfo, String])
], TableInfo);
exports.TableInfo = TableInfo;
/**
 * Represents information about a projection.
 */
let ProjectionInfo = class ProjectionInfo {
    constructor(operand, type, func, name, jsonb, modifierInfo, isSensitive, defaultValue, jsonb_type, precedence, values, funcArgs, funcArgTypes, queryLevel) {
        this.operand = operand;
        this.type = type;
        this.func = func;
        this.name = name;
        this.jsonb = jsonb;
        this.modifierInfo = modifierInfo;
        this.jsonb_type = jsonb_type;
        this.isSensitive = isSensitive;
        this.values = values;
        this.precedence = precedence;
        this.defaultValue = defaultValue;
        this.funcArgs = funcArgs;
        this.funcArgTypes = funcArgTypes;
        this.queryLevel = queryLevel;
    }
};
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], ProjectionInfo.prototype, "operand", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], ProjectionInfo.prototype, "type", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], ProjectionInfo.prototype, "func", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], ProjectionInfo.prototype, "name", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], ProjectionInfo.prototype, "jsonb", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], ProjectionInfo.prototype, "jsonb_type", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Boolean)
], ProjectionInfo.prototype, "isSensitive", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], ProjectionInfo.prototype, "defaultValue", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", ModifierInfo)
], ProjectionInfo.prototype, "modifierInfo", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Number)
], ProjectionInfo.prototype, "precedence", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Array)
], ProjectionInfo.prototype, "values", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Object)
], ProjectionInfo.prototype, "funcArgs", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Object)
], ProjectionInfo.prototype, "funcArgTypes", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], ProjectionInfo.prototype, "queryLevel", void 0);
ProjectionInfo = __decorate([
    (0, typescript_json_serializer_1.JsonObject)(),
    __metadata("design:paramtypes", [String, String, String, String, String, ModifierInfo, Boolean, String, String, Number, Array, Object, Object, String])
], ProjectionInfo);
exports.ProjectionInfo = ProjectionInfo;
/**
 * Represents information about a filter condition.
 */
let FilterInfo = class FilterInfo {
    constructor(operand, operator, value, type, e_operator, precedence, group, jsonb, compute, func, funcArgs, funcArgTypes, interval, comparison, modifierInfo, // this will. be used in future , Currently not in support
    period, attributeList, journey, action, category, tag, dwell, dw, details, fileInfo, queryLevel) {
        this.operand = operand;
        this.operator = operator;
        this.value = value;
        this.type = type;
        this.e_operator = e_operator;
        this.precedence = precedence;
        this.group = group;
        this.jsonb = jsonb;
        this.compute = compute;
        this.func = func;
        this.funcArgs = funcArgs;
        this.funcArgTypes = funcArgTypes;
        this.interval = interval;
        this.modifierInfo = modifierInfo, // this will. be used in future , Currently not in support
            this.comparison = comparison;
        this.period = period;
        this.attributeList = attributeList;
        this.journey = journey;
        this.action = action;
        this.tag = tag;
        this.category = category;
        this.dwell = dwell,
            this.dw = dw,
            this.details = details,
            this.fileInfo = fileInfo;
        this.queryLevel = queryLevel;
    }
};
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], FilterInfo.prototype, "operand", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], FilterInfo.prototype, "operator", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Array)
], FilterInfo.prototype, "value", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], FilterInfo.prototype, "type", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], FilterInfo.prototype, "e_operator", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Number)
], FilterInfo.prototype, "precedence", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Array)
], FilterInfo.prototype, "group", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], FilterInfo.prototype, "jsonb", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], FilterInfo.prototype, "jsonb_type", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Boolean)
], FilterInfo.prototype, "compute", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], FilterInfo.prototype, "func", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Object)
], FilterInfo.prototype, "funcArgs", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Object)
], FilterInfo.prototype, "funcArgTypes", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], FilterInfo.prototype, "interval", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], FilterInfo.prototype, "comparison", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], FilterInfo.prototype, "period", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", ModifierInfo)
], FilterInfo.prototype, "modifierInfo", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Array)
], FilterInfo.prototype, "attributes", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Array)
], FilterInfo.prototype, "attributeList", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], FilterInfo.prototype, "dropoff_operand", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], FilterInfo.prototype, "dropoff_attribute", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], FilterInfo.prototype, "queryLevel", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Object)
], FilterInfo.prototype, "dropoff", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Number)
], FilterInfo.prototype, "count", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Number)
], FilterInfo.prototype, "avg_step_duration", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Number)
], FilterInfo.prototype, "avg_tot_duration", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], FilterInfo.prototype, "journey", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], FilterInfo.prototype, "action", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], FilterInfo.prototype, "tag", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], FilterInfo.prototype, "category", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Number)
], FilterInfo.prototype, "dwell", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Number)
], FilterInfo.prototype, "dw", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", geofencing_1.GeoFencingDetails)
], FilterInfo.prototype, "details", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Object)
], FilterInfo.prototype, "fileInfo", void 0);
FilterInfo = __decorate([
    (0, typescript_json_serializer_1.JsonObject)(),
    __metadata("design:paramtypes", [String, String, Array, String, String, Number, Array, String, Boolean, String, Object, Object, String, String, ModifierInfo, String, Array, String, String, String, String, Number, Number, geofencing_1.GeoFencingDetails, Object, String])
], FilterInfo);
exports.FilterInfo = FilterInfo;
/**
 * Represents the payload for querying different types of data.
 */
let QueryPayload = class QueryPayload extends base_1.BaseModel {
    constructor({ name, description, tableInfo, projectionInfo, filterInfo, audid, days, status, modifierInfo, sd, ed, p, journey, uniqueCount, aud, segmentinfo, interval, intervalUnit }) {
        super();
        this.name = name;
        this.description = description;
        this.tableInfo = tableInfo;
        this.projectionInfo = projectionInfo;
        this.filterInfo = filterInfo;
        this.audid = audid;
        this.days = days;
        this.status = status;
        this.modifierInfo = modifierInfo;
        this.sd = sd;
        this.ed = ed;
        this.p = p;
        this.journey = journey;
        this.uniqueCount = uniqueCount;
        this.aud = aud;
        this.segmentinfo = segmentinfo;
        this.interval = interval;
        this.intervalUnit = intervalUnit;
    }
};
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], QueryPayload.prototype, "name", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], QueryPayload.prototype, "description", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", TableInfo)
], QueryPayload.prototype, "tableInfo", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Array)
], QueryPayload.prototype, "projectionInfo", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Array)
], QueryPayload.prototype, "filterInfo", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", ModifierInfo)
], QueryPayload.prototype, "modifierInfo", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Number)
], QueryPayload.prototype, "days", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], QueryPayload.prototype, "audid", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], QueryPayload.prototype, "_id", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], QueryPayload.prototype, "status", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Number)
], QueryPayload.prototype, "sd", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Number)
], QueryPayload.prototype, "ed", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Array)
], QueryPayload.prototype, "p", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], QueryPayload.prototype, "journey", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Number)
], QueryPayload.prototype, "interval", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], QueryPayload.prototype, "intervalUnit", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Boolean)
], QueryPayload.prototype, "uniqueCount", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], QueryPayload.prototype, "fileName", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], QueryPayload.prototype, "email", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Boolean)
], QueryPayload.prototype, "aud", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", segmentinfo_1.SegmentInfo)
], QueryPayload.prototype, "segmentinfo", void 0);
QueryPayload = __decorate([
    (0, typescript_json_serializer_1.JsonObject)(),
    __metadata("design:paramtypes", [QueryPayload])
], QueryPayload);
exports.QueryPayload = QueryPayload;
